import React from 'react';
import { Form, Checkbox } from 'antd';
import { Input, Button } from '@gamesb42/ui-kit';

interface SignupFormData {
  email: string;
  first_name: string;
  last_name: string;
  company_name: string;
  password: string;
  agree: boolean;
}

interface SignupFormProps {
  loading: boolean;
  onFinish: (values: SignupFormData) => void;
  onLoginClick: () => void;
}

const SignupForm: React.FC<SignupFormProps> = ({
  loading,
  onFinish,
  onLoginClick,
}) => {
  const [form] = Form.useForm();

  return (
    <>
      <h2
        style={{
          marginBottom: '20px',
          textAlign: 'left',
          color: '#090909',
          fontSize: '32px',
          fontWeight: 700,
          lineHeight: '40px',
          fontFamily: 'Muller',
        }}
      >
        Create your account and{' '}
        <span style={{ color: '#7145ec' }}>start earning revenue</span>
      </h2>

      <div style={{ marginBottom: '32px' }}>
        Already registered?{' '}
        <span
          style={{
            color: '#7145ec',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={onLoginClick}
        >
          Sign in
        </span>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input label="Email" size="large" />
        </Form.Item>

        <Form.Item
          name="first_name"
          rules={[{ required: true, message: 'Please input your first name!' }]}
        >
          <Input label="First Name" size="large" />
        </Form.Item>

        <Form.Item
          name="last_name"
          rules={[{ required: true, message: 'Please input your last name!' }]}
        >
          <Input label="Last Name" size="large" />
        </Form.Item>

        <Form.Item
          name="company_name"
          rules={[
            { required: true, message: 'Please input your company name!' },
          ]}
        >
          <Input label="Company Name" size="large" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your password!' },
            {
              min: 8,
              pattern:
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%#?&])[A-Za-z\d@$!%#?&]{8,}$/,
              message:
                'Password must be at least 8 characters and contain letters, numbers, and special characters (@$!%#?&)',
            },
          ]}
        >
          <Input
            label="Password"
            size="large"
            type="password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="agree"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error('You must agree to the terms')),
            },
          ]}
          style={{ marginBottom: '32px' }}
        >
          <Checkbox style={{ alignItems: 'flex-start' }}>
            By clicking the "Create account" button, you are creating a
            GamesBoost42 account, and you agree to GamesBoost42's{' '}
            <a
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Terms_of_Service.pdf"
              style={{ color: '#7145ec' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Privacy_Policy.pdf"
              style={{ color: '#7145ec' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            style={{
              backgroundColor: '#7145ec',
              borderColor: '#7145ec',
              color: '#fff',
              width: '94px',
            }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SignupForm;
